import React, { useState} from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { doReportDelete } from "../../../../redux/report/reportState";

const ReportTable = ({doDelete, tableData, ...props}) => {
  	
  	const columns = [
		{
	        title: `Title`,
	        dataIndex: 'rpt_title',
	        key: 'rpt_title',
	        width: '25%',
	        render:(rpt_title) => <span>{rpt_title}</span>
	    },
	    {
	        title: `Description`,
	        dataIndex: 'rpt_description',
	        key: 'rpt_description',
	        width: '48%',
	        render:(rpt_description) => <span>{rpt_description}</span>  
	    },
	    {
	        title: `Status`,
	        dataIndex: 'rpt_status_id',
	        key: 'rpt_status_id',
	        width: '15%',	       
	    },	    
	    {
	        title: 'Action',
	        dataIndex: 'rpt_id',
	        key: 'rpt_id',
	        width: '12%',
	        render:(rpt_id) => <CrudOption baseRoute="/console/reports" recordId={rpt_id} allowEdit={false} allowDelete={false} deleteHandler={doDelete}/>
	    },
    ];
    
	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 10,
	});

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={tableData} 
		        	columns={columns} 
		            rowKey={(record) => record.rpt_id}
		        	pagination={pagination}    
		            onChange={(pagination) => setPagination(pagination)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  doDelete: (id) => dispatch(doReportDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportTable);